// extracted by mini-css-extract-plugin
module.exports = {"generalInfoWrapper":"GeneralInfo_generalInfoWrapper__2XTBv","generalInfoImage":"GeneralInfo_generalInfoImage__QmZcu"};